export const withdrawalMethodsEndpoint =
  '/cashier-core-ms/v1/withdrawal/methods';

export const withdrawalLastEndpoint = '/cashier-core-ms/v1/withdrawal/last';

export const withdrawalRequestEndpoint =
  '/cashier-core-ms/v1/withdrawal/request';

export const withdrawalCredentialsEndpoint =
  '/cashier-core-ms/v1/withdrawal/credentials';

export const withdrawalDetailsEndpoint =
  '/cashier-core-ms/v1/withdrawal/details';

export const WithdrawalMode = {
  default: '0_0',
  bankTransfer: '1_9',
  pdvGedea: '8_104',
  posteContoBPOL: '3_9',
  postePostpay: '2_1',
  safeChargeMasterCard: '9_1',
  safeChargeVisa: '9_2',
  safeChargePaypal: '9_3',
  safeChargePaysafe: '9_4',
  safeChargeNeteller: '9_5',
  safeChargeSkrill: '9_6',
  safeChargeSkrillOneTap: '9_7',
  applepay: '9_8',
  directBankTransfer: '9_9',
} as const;
